import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import booking_bg_3 from "../assets/img/booking_bg_3.png";
import { Link } from "react-router-dom";
import CarrerImageBanner from "../assets/img/CarrerImageBanner.jpg";
import { useFormik } from "formik";
import axios from "axios";
import { motion } from "framer-motion";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReCAPTCHA from "react-google-recaptcha";

function Career() {
  useEffect(() => {
    document.title = "Zeppoli Bakers | Career";
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  const [fullNameError, setFullNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobileNumberError, setMobileNumberError] = useState("");
  const [resumeError, setResumeError] = useState("");
  const [captchaValue, setCaptchaValue] = useState("");
  const [captchaValueError, setCaptchaValueError] = useState("");

  // Handle reCAPTCHA change
  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
    setCaptchaValueError("");
  };

  const formik = useFormik({
    initialValues: {
      fullName: "",
      email: "",
      mobileNumber: "",
      resume: "",
    },
    onSubmit: async (values, { resetForm }) => {
      let errorMessage = 0;
      const fullNameValidation = /^[a-zA-Z\s]+(?: [a-zA-Z\s]+)*$/;
      const mobileNumberValidation = /^\d{10}$/;
      const emailValidation = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const resumeTypeValidation = [
        "image/png",
        "image/jpg",
        "image/jpeg",
        "application/pdf",
      ];

      if (values.fullName === "") {
        setFullNameError("Full Name is Required");
        errorMessage++;
      } else if (!values.fullName.match(fullNameValidation)) {
        setFullNameError("Full Name Must Be Valid");
        errorMessage++;
      }

      if (values.mobileNumber === "") {
        setMobileNumberError("Mobile Number is Required");
        errorMessage++;
      } else if (!values.mobileNumber.match(mobileNumberValidation)) {
        setMobileNumberError("Mobile Number Must Be Valid");
        errorMessage++;
      } else if (values.mobileNumber == "0000000000") {
        setMobileNumberError("Mobile Number Must Be Valid");
        errorMessage++;
      }

      if (values.email === "") {
        setEmailError("Email is Required");
        errorMessage++;
      } else if (!values.email.match(emailValidation)) {
        setEmailError("Email Must Be Valid");
        errorMessage++;
      }

      if (values.resume === "") {
        setResumeError("Resume is Required");
        errorMessage++;
      } else if (
        values.resume &&
        !resumeTypeValidation.includes(values.resume.type)
      ) {
        setResumeError("Resume Must Be Valid");
        errorMessage++;
      }

      const data = new FormData();
      data.append("fullName", values.fullName);
      data.append("email", values.email);
      data.append("mobileNumber", values.mobileNumber);

      if (typeof values.resume === "string") {
        data.append("resume", values.resume);
      } else {
        data.append("resume", values.resume);
      }

      if (errorMessage == 0) {
        if (captchaValue !== "") {
          const response = await axios.post(
            "https://serverapi.xpertlab.com/zeppoli/careerapplicationform",
            data,
            {
              headers: {
                apitoken: "b361d6655jrsd4dd02efaf412ed585sd",
                "Content-Type": "multipart/form-data",
              },
            }
          );
          if (response.status === 200) {
            if (response.data.status === 200) {
              toast.success("Data Submitted Successfully");
              setTimeout(() => {
                window.location.reload();
              }, 1500);
            } else {
              toast.error("Please Fill the Form");
            }
          } else {
            toast.error("Something Went Wrong");
          }
        } else {
          setCaptchaValueError("Please Check Captcha");
        }
      }
    },
  });

  // for animation begin
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    // Cleanup timeout if the component unmounts
    return () => clearTimeout(timer);
  }, []);
  // upside animation
  const variants5 = {
    hidden: { opacity: 0, y: 100 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2,
        type: "spring",
        stiffness: 50,
        damping: 20,
      },
    }),
  };
  // left side animation
  const leftSide = {
    hidden: {
      opacity: 0,
      x: screenSize < 401 ? -100 : screenSize < 739 ? -100 : -200,
    },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.2,
        type: "spring",
        stiffness: 50,
        damping: 20,
      },
    }),
  };
  // for animation end

  return (
    <>
      <ToastContainer />
      <Navbar />

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={variants5}
      >
        <div className="breadcumb-wrapper " data-bg-src={CarrerImageBanner}>
          <div
            className="container z-index-common"
            style={{ marginTop: "150px" }}
          >
            <div className="breadcumb-content">
              <h1 className="breadcumb-title text-white">Career</h1>
              <ul className="breadcumb-menu">
                <li>
                  <Link className="text-white" to="/">
                    Home
                  </Link>
                </li>
                <li className="text-white">Career</li>
              </ul>
            </div>
          </div>
        </div>
      </motion.div>

      {isVisible && (
        <section className="space">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={leftSide}
          >
            <div className="container mb-gutter-negative">
              <p className="sub-title">Career In Zeppoli Bakers</p>
              <div className="title-area">
                <h1 className="sec-title">
                  Cool Career Paths at Zeppoli Bakers
                </h1>
                <p>
                  As a Master Zeppoli Baker, you embark on a delectable journey
                  where your passion for pastry perfection meets the art of
                  creating heavenly Zeppoli. With a flair for precision and a
                  touch of creativity, you knead, shape, and fry dough into
                  golden perfection, transforming simple ingredients into
                  mouthwatering delights.
                </p>
                <p>
                  Your expertise extends beyond the kitchen, as you experiment
                  with flavors, fillings, and presentation to elevate Zeppoli to
                  an exquisite level. You're not just a baker; you're a culinary
                  artist, infusing every creation with a sprinkle of magic that
                  delights the senses.
                </p>
                <p>
                  In this career, you'll blend tradition with innovation,
                  crafting Zeppoli that not only taste divine but also tell a
                  story. Your keen attention to detail ensures that each bite is
                  a moment of joy for those savoring your creations. As a Master
                  Zeppoli Baker, you become a maestro of sweetness, creating an
                  experience that lingers in the hearts and taste buds of those
                  who indulge in your culinary masterpieces.
                </p>
                <p>
                  In this dynamic and rewarding career, you'll find yourself at
                  the forefront of a bustling bakery, working seamlessly with a
                  team dedicated to the pursuit of perfection. Your role extends
                  beyond the oven, encompassing the planning and execution of
                  daily production, ensuring that the aroma of freshly fried
                  Zeppoli wafts through the air, enchanting customers and
                  passersby alike.
                </p>
              </div>
            </div>
          </motion.div>
        </section>
      )}

      <section
        className="booking-sec1 space mb-4"
        id="bookingSec1"
        data-bg-src={booking_bg_3}
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-7">
              {isVisible && (
                <>
                  <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={variants5}
                  >
                    <div className="title-area text-center text-xl-start mb-30">
                      <span className="text-white">
                        Career Application Form
                      </span>
                      <h2 className="sec-title text-white">Apply Now</h2>
                    </div>
                    <div className="booking-form3">
                      <form
                        onSubmit={formik.handleSubmit}
                        encType="multipart/form-data"
                      >
                        <div className="row">
                          <div className="form-group col-md-6">
                            <input
                              type="text"
                              className="form-control rounded-2"
                              placeholder="Full Name"
                              {...formik.getFieldProps("fullName")}
                              onChange={(e) => {
                                formik.setFieldValue(
                                  "fullName",
                                  e.target.value
                                );
                                setFullNameError("");
                              }}
                            />
                            <i className="far fa-user"></i>
                            <span className="text-danger">{fullNameError}</span>
                          </div>
                          <div className="form-group col-md-6">
                            <input
                              type="text"
                              className="form-control rounded-2"
                              placeholder="Email Address"
                              {...formik.getFieldProps("email")}
                              onChange={(e) => {
                                formik.setFieldValue("email", e.target.value);
                                setEmailError("");
                              }}
                            />
                            <i className="fal fa-envelope"></i>
                            <span className="text-danger">{emailError}</span>
                          </div>
                          <div className="form-group col-12">
                            <input
                              type="text"
                              className="form-control rounded-2"
                              placeholder="Mobile Number"
                              {...formik.getFieldProps("mobileNumber")}
                              onChange={(e) => {
                                formik.setFieldValue(
                                  "mobileNumber",
                                  e.target.value
                                );
                                setMobileNumberError("");
                              }}
                            />
                            <i className="far fa-phone"></i>
                            <span className="text-danger">
                              {mobileNumberError}
                            </span>
                          </div>
                          <label
                            className="text-white fs-5"
                            htmlFor="uploadResume"
                          >
                            Upload Resume
                          </label>
                          <div className="form-group col-12">
                            <input
                              type="file"
                              className="form-control rounded-2 py-3"
                              placeholder="Select Date"
                              onChange={(event) => {
                                if (
                                  event.target.files &&
                                  event.target.files[0]
                                ) {
                                  formik.setFieldValue(
                                    "resume",
                                    event.target.files[0]
                                  );
                                }
                              }}
                            />
                            <i className="far fa-file"></i>
                            <span className="text-danger">{resumeError}</span>
                          </div>
                          <div className="form-group col-12">
                            <div className="fw-bold text-primary mt-4 mx-2">
                              <ReCAPTCHA
                                sitekey="6Lfm3PcqAAAAACvfCZKWxwHJssSxiAODpGFvIE0A"
                                onChange={handleCaptchaChange}
                              />
                              <span className="text-danger">
                                {captchaValueError}
                              </span>
                            </div>
                          </div>
                          <div className="form-btn col-12 text-center text-xl-start">
                            <button
                              type="submit"
                              className="th-btn style3 rounded-2"
                              name="formSubmit"
                              aria-label="formSubmit"
                            >
                              Submit
                              <i className="fa-solid fa-arrow-right ms-2"></i>
                            </button>
                          </div>
                        </div>
                      </form>
                      <p className="form-messages mb-0 mt-3"></p>
                    </div>
                  </motion.div>
                </>
              )}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Career;
